import React from 'react'
import axiosClient from '../api/axiosClient'
import AddTicketSolidIcon from '../components/Icons/AddTicketSolidIcon'
import ReactionGestureSolidIcon from '../components/Icons/ReactionGestureSolidIcon'
import TicketCheckSolidIcon from '../components/Icons/TicketCheckSolidIcon'
import FollowerSolidIcon from '../components/Icons/FollowerSolidIcon'
import NearbySolidIcon from '../components/Icons/NearbySolidIcon'
import NotificationSolidIcon from '../components/Icons/NotificationSolidIcon'
import { theme } from '../theme'
import Typography from '../components/Typography'
import i18n from '../i18n'
import FollowUserSolidIcon from '../components/Icons/FollowUserSolidIcon'
import TicketSolidIcon from '../components/Icons/TicketSolidIcon'
import VehicleIcon from '../components/Icons/VehicleIcon'
import ProfileIconOutline from '../components/Icons/ProfileIconOutline'

export function buildNotificationTitle(it) {
  const t = it.type
  const title = it?.metadata?.eventTitle || it?.metadata?.vehicleName || ''
  const actorName = (it?.metadata?.actorName) || `${it?.actorId?.name || ''} ${it?.actorId?.lastName || ''}`.trim()
  if (t === 'publish_event') {
    return (
      <Typography as="p" $variant="body-1-medium" color={theme.colors.defaultStrong}>
        {actorName && <Typography $variant="body-1-semibold" color={theme.colors.defaultMain}>{actorName} </Typography>}
        <Typography>{i18n.t('userProfile:notifications.messages.publishEvent')} </Typography>
        <Typography $variant="body-1-medium" color={theme.colors.defaultMain} style={{ textDecoration: 'underline' }}>{title}</Typography>
      </Typography>
    )
  }
  if (t === 'attend_event') {
    return (
      <Typography as="p" $variant="body-1-medium" color={theme.colors.defaultStrong}>
        {actorName && <Typography $variant="body-1-semibold" color={theme.colors.defaultMain}>{actorName} </Typography>}
        <Typography>{i18n.t('userProfile:notifications.messages.attendEvent')} </Typography>
        <Typography $variant="body-1-medium" color={theme.colors.defaultMain} style={{ textDecoration: 'underline' }}>{title}</Typography>
      </Typography>
    )
  }
  if (t === 'vehicle_reaction') {
    return (
      <Typography as="p" $variant="body-1-medium" color={theme.colors.defaultStrong}>
        {actorName && <Typography $variant="body-1-semibold" color={theme.colors.defaultMain}>{actorName} </Typography>}
        <Typography>{i18n.t('userProfile:notifications.messages.vehicleReaction')} </Typography>
        <Typography $variant="body-1-medium" color={theme.colors.defaultMain} style={{ textDecoration: 'underline' }}>{title}</Typography>
      </Typography>
    )
  }
  if (t === 'follow_user') {
    return (
      <Typography as="p" $variant="body-1-medium" color={theme.colors.defaultStrong}>
        {actorName && <Typography $variant="body-1-semibold" color={theme.colors.defaultMain}>{actorName} </Typography>}
        <Typography>{i18n.t('userProfile:notifications.messages.followUser')}</Typography>
      </Typography>
    )
  }
  if (t === 'nearby_event') {
    return (
      <Typography as="p" $variant="body-1-medium" color={theme.colors.defaultStrong}>
        <Typography>{i18n.t('userProfile:notifications.messages.nearbyEventPrefix')} </Typography>
        <Typography $variant="body-1-medium" color={theme.colors.defaultMain} style={{ textDecoration: 'underline' }}>{title}</Typography>
      </Typography>
    )
  }
  return (
    <Typography as="p" $variant="body-1-medium" color={theme.colors.defaultStrong}>Actividad</Typography>
  )
}

export function buildNotificationActions(it, navigate, followingSet, onFollowSuccess) {
  const t = it.type
  const slug = it?.metadata?.eventSlug
  if (t === 'follow_user') {
    const actorId = (it?.actorId && (it.actorId._id || it.actorId.id)) || it.actorId
    const actions = []
    const alreadyFollowing = Boolean(followingSet && actorId && followingSet.has(String(actorId)))
    if (!alreadyFollowing) {
      actions.push({
        label: i18n.t('userProfile:notifications.actions.followAlso'),
        variant: 'outline',
        icon: <FollowUserSolidIcon width={16} height={16} fill={theme.colors.defaultMain} />,

        onClick: async () => {
          try {
            await axiosClient.post(`/api/users/${actorId}/follow`)
            if (onFollowSuccess) onFollowSuccess(String(actorId))
          } catch (e) { }
        }
      })
    }
    return actions
  }
  return []
}

export function buildNotificationPrimaryAction(it, navigate, openInNewTab = false) {
  const t = it.type
  const slug = it?.metadata?.eventSlug
  if (t === 'publish_event' || t === 'attend_event' || t === 'nearby_event') {
    const url = `/events/${it.eventId}/${slug}`
    return {
      onClick: () => {
        if (openInNewTab) {
          window.open(url, '_blank')
        } else {
          navigate(url)
        }
      }
    }
  }
  if (t === 'vehicle_reaction') {
    const url = `/user/${it.targetUserId}/garage`
    return {
      onClick: () => {
        if (openInNewTab) {
          window.open(url, '_blank')
        } else {
          navigate(url)
        }
      }
    }
  }
  if (t === 'follow_user') {
    const actorId = (it?.actorId && (it.actorId._id || it.actorId.id)) || it.actorId
    const url = `/user/${actorId}`
    return {
      onClick: () => {
        if (openInNewTab) {
          window.open(url, '_blank')
        } else {
          navigate(url)
        }
      }
    }
  }
  return { onClick: () => { } }
}

export function buildNotificationIcon(it) {
  const t = it.type
  switch (t) {
    case 'publish_event':
      return <AddTicketSolidIcon height={16} width={16} fill={theme.fill.brandMain} />
    case 'attend_event':
      return <TicketCheckSolidIcon height={16} width={16} fill={theme.fill.brandMain} />
    case 'vehicle_reaction':
      return <ReactionGestureSolidIcon height={16} width={16} fill={theme.fill.brandMain} />
    case 'follow_user':
      return <FollowerSolidIcon height={16} width={16} fill={theme.fill.brandMain} />
    case 'nearby_event':
      return <NearbySolidIcon height={16} width={16} fill={theme.fill.brandMain} />
    default:
      return <NotificationSolidIcon height={16} width={16} fill={theme.fill.brandMain} />
  }
}
